import { getEksList,  getEksStatus} from "@/apis";

export const RESOURCE_TYPE_EKS = "eks";

export const EksDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await getEksList();
    const data = response.value;
    return {
        data,
        total: data.length,
    };
  },
  getOne: async ({ resource, id, meta }) => {
    const data = await getEksStatus(id);
    return data.value;
  },
  create: async ({resource, variables, meta}) => {    
    throw new Error("Function not implemented.");
  },
  update: async ({ resource, id, variables: { action, data } }) => {
    throw new Error("Function not implemented.");
  },
  deleteOne: async ({ resource, id }) => {
    throw new Error("Function not implemented.");
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};